import { useCallback } from 'react'

import { config } from '@fairhq/common'
import { useAuthContext } from 'auth/context/useAuthContext'
import { AuthErrorEnum } from 'auth/types'
import { emptySplitApi } from 'emptySplitApi'
import { clearAll } from 'store/clear'

import { useAppDispatch } from '../store/hooks'

export function useSignOut() {
  const dispatch = useAppDispatch()
  const { logout } = useAuthContext()
  const signOut = useCallback(async () => {
    dispatch(clearAll())
    dispatch(emptySplitApi.util.resetApiState())
    localStorage.removeItem(config.employee)
    logout(AuthErrorEnum.LOGOUT)
  }, [dispatch, logout])

  return signOut
}
